/* eslint no-unused-vars: "off" */
import React, { useContext, useState } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { NavigateToWindowWithNativeEvents, OpenInNewTabWithNativeEvents } from '@components/_common/link/link';
import { useIntersectionObserver } from 'usehooks-ts';
import Card from '../_common/card/Card';
import CarvanaCareDetails from '../_common/carvana-care-details/CarvanaCareDetails';
import { CarvanaCareStatusInfo } from '../_common/carvana-care-status-info/CarvanaCareStatusInfo';
import {
  CarvanaCareCardWrapper,
  ContentWrapper,
  Content,
  Button,
  ButtonWrapper,
  BoldTitle,
  BodyTitle,
} from './CarvanaCareCard.styles';
import CarvanaCareIcon from '../../assets/CarvanaCareIcon';
import { AnalyticEvents } from '../../constants';

const CarvanaCareCard = ({ feedData, positionValue }: any) => {
  const { trackEvent } = useContext(AnalyticsContext) as any;
  const [cardPosition] = useState(positionValue || 0);
  const {
    id: cardId,
    title,
    callToAction: { title: buttonText, link },
    content: {
      carvanaCare: { type, protectionMiles, durationLeft, isExpired, brochureUrl },
    },
  } = feedData;

  // Redirect to post sale updates page
  const handleRedirect = () => {
    trackEvent(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
      type: [type.toLowerCase()],
      isExpired: [isExpired],
    });
    datadogRum.addAction(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
      type: [type.toLowerCase()],
      isExpired: [isExpired],
    });
    NavigateToWindowWithNativeEvents({
      url: link,
      event: 'link',
    });
  };

  const captureImpression = () => {
    setTimeout(() => {
      trackEvent(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
        type: [type.toLowerCase()],
        isExpired: [isExpired],
      });
      datadogRum.addAction(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
        type: [type.toLowerCase()],
        isExpired: [isExpired],
      });
    }, 1000);
  };
  const { ref } = useIntersectionObserver({
    freezeOnceVisible: true,
    threshold: 0.5,
    onChange: (isIntersecting, entry) => {
      if (isIntersecting && captureImpression) captureImpression();
    },
  });

  const header = {
    title: (
      <>
        <BoldTitle>
          CarvanaCare&nbsp;<BodyTitle>{title}</BodyTitle>
        </BoldTitle>
      </>
    ),
    statusInfo: <CarvanaCareStatusInfo protectionMiles={protectionMiles} durationLeft={durationLeft} />,
  };

  const careDetails = feedData?.content?.carvanaCare || {};

  const handleCareUrlClick = () => {
    OpenInNewTabWithNativeEvents({
      url: brochureUrl,
      event: 'link',
    });
  };

  return (
    <CarvanaCareCardWrapper ref={ref}>
      <Card dataQa="carvana-care" header={header} headerIcon={<CarvanaCareIcon />}>
        <ContentWrapper>
          <Content>
            <CarvanaCareDetails careDetails={careDetails} />
          </Content>
          <ButtonWrapper>
            <Button data-testid="carvana-care-full-coverage-button" size="small" onClick={() => handleCareUrlClick()}>
              View Full Coverage
            </Button>
            <Button data-testid="carvana-care-cta-button" size="small" onClick={handleRedirect}>
              {buttonText}
            </Button>
          </ButtonWrapper>
        </ContentWrapper>
      </Card>
    </CarvanaCareCardWrapper>
  );
};

export default CarvanaCareCard;
